import ModalSurface from '../shared/ModalSurface';
import { useState, useEffect, useMemo, useCallback } from 'react';

function ImportModal({ onClose, onImport }) {
    const [csvText, setCsvText] = useState('');
    const handleImport = () => { if (!csvText.trim()) { alert('Please paste CSV data'); return; } onImport(csvText); };
    return (
        <ModalSurface panelProps={{ 'data-m7-touch': true }} onClose={onClose} label="Import Thryv CSV Data" panelClassName="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="ia-modal-layout p-6">
                    <h3 className="text-2xl font-bold mb-4">Import Thryv CSV Data</h3>
                    <div className="ia-modal-body">
                    <p className="text-sm text-gray-600 mb-4">Paste your Thryv CSV export below. Include the header row.</p>
                    <textarea value={csvText} onChange={(e) => setCsvText(e.target.value)} rows="20"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[var(--accent-ink)] font-mono text-sm"
                        placeholder="Client,Client First Name,Client Last Name,Client Email,Client Phone,Client Address,Status,Open Payments,Notes&#10;Amy,Amy,Berryhill,amybaker84@gmail.com,+1 (804) 514-7720,..." />
                    </div>
                    <div className="ia-modal-actions flex justify-end gap-3 mt-6">
                        <button onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Cancel</button>
                        <button onClick={handleImport} className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">📤 Import Data</button>
                    </div>
                </div>
        </ModalSurface>
    );
}


export default ImportModal;
